import { pdfCustomFieldsTranslations } from './pdf-custom-fields-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
/** Translations of the visual PDF template designer; wired up in lib/i18n/en.ts. */
export const pdfDesignerEs = {
  customFields: pdfCustomFieldsTranslations.es,
  list: {
    title: 'Plantillas PDF',
    subtitle:
      'Diseña los diseños de documentos sin programar y asígnalos según el tipo de documento.',
    cardTitle: 'Plantillas',
    cardDescription:
      'La plantilla predeterminada de un tipo de documento se aplica automáticamente al imprimir.',
    filter: 'Filtrar por tipo de documento',
    allTypes: 'Todos los tipos de documentos',
    create: 'Nueva plantilla',
    created: 'La plantilla ha sido creada.',
    createTitle: 'Crear plantilla',
    createDescription:
      'Elige un tipo de documento y un diseño inicial; ambos permanecen editables.',
    preset: 'Diseño inicial',
    presetHint:
      'El ajuste preestablecido define márgenes, fuentes, bloques de construcción y columnas.',
    active: 'Activo',
    inactive: 'Inactivo',
    error: 'No se pudieron cargar las plantillas.',
    emptyTitle: 'Aún no hay plantilla',
    emptyHint: 'Crea una plantilla para diseñar el diseño de impresión de tus documentos.',
    columns: {
      name: 'Nombre',
      documentType: 'Tipo de documento',
      status: 'Estado',
      updatedAt: 'Último cambio',
    },
  },
  documentTypes: {
    QUOTE: 'Cotización',
    ORDER: 'Confirmación de pedido',
    DELIVERY_NOTE: 'Nota de entrega',
    INVOICE: 'Factura',
    PURCHASE_ORDER: 'Orden de compra',
    ALL: 'Todos los tipos de documentos',
  },
  presets: {
    CLASSIC_DIN5008: 'Clásico DIN 5008',
    MODERN_MINIMALIST: 'Moderno minimalista',
    COMPACT: 'Compacto',
  },
  blocks: {
    RECEIVING_HOURS: deliveryPlanningTranslations.es.receiving,
    TRANSPORT_PLAN: deliveryPlanningTranslations.es.transport,
    LOGO: 'Logo de la empresa',
    SENDER_LINE: 'Línea del remitente',
    RECIPIENT_ADDRESS: 'Campo de dirección',
    DOCUMENT_META: 'Cuadro de datos del documento',
    HEADER_TEXT: 'Línea de asunto',
    CUSTOMER_HEADER: 'Datos del cliente en la cabecera',
    ITEMS_TABLE: 'Tabla de partidas',
    SHIPPING_SUMMARY: 'Embalajes y peso',
    TOTALS_BLOCK: 'Bloque de totales',
    GIROCODE_QR: 'QR GiroCode',
    FOOTER_TEXT: 'Condiciones de pago',
    FOOTER_COLUMNS: 'Pie de página de tres columnas',
    CUSTOM_HTML_TEXT: 'Texto libre',
  },
  columns: {
    position: 'Artículo',
    sku: 'Número de artículo',
    name: 'Descripción',
    description: 'Detalles',
    batchNumber: 'Lote',
    expiryDate: 'Fecha de caducidad',
    quantity: 'Cantidad',
    unit: 'Unidad',
    unitPrice: 'Precio unitario',
    discountPercent: 'Descuento',
    taxRate: 'Tasa de IVA',
    lineTotal: 'Total neto',
  },
  toolbar: {
    name: 'Nombre de la plantilla',
    isDefault: 'Predeterminado',
    unsaved: 'Cambios no guardados',
    editMode: 'Modo de edición',
    previewMode: 'Vista previa PDF en vivo',
    undo: 'Deshacer',
    redo: 'Rehacer',
    resetPreset: 'Restablecer a la configuración predeterminada',
    duplicate: 'Duplicar',
    setDefault: 'Establecer como predeterminado',
    save: 'Guardar y activar',
  },
  library: {
    title: 'Bloques de construcción',
    usedTitle: 'Bloques en uso',
    add: 'Agregar {{block}}',
  },
  canvas: {
    dragHandle: 'Mover bloque',
    hide: 'Ocultar bloque',
    show: 'Mostrar bloque',
    remove: 'Eliminar bloque',
    empty: 'Arrastre los bloques de construcción desde la columna izquierda hacia la página.',
    resizeColumn: 'Ajustar el ancho de la columna {{column}}',
    customerHeaderConfigured: 'Campos del diseño guardado del documento',
    customerHeaderFields: '{{count}} campos de cliente seleccionados',
  },
  inspector: {
    pageTitle: 'Página',
    marginsTitle: 'Márgenes de la página (mm)',
    margin: {
      top: 'Superior',
      bottom: 'Inferior',
      left: 'Izquierda',
      right: 'Derecha',
    },
    typographyTitle: 'Tipografía',
    fontFamily: 'Familia de fuentes',
    baseFontSize: 'Tamaño base (pt)',
    lineHeight: 'Altura de línea',
    colorsTitle: 'Colores',
    primaryColor: 'Color principal',
    secondaryColor: 'Color secundario',
    textColor: 'Color del texto',
    din5008Title: 'DIN 5008',
    showFoldMarks: 'Mostrar marcas de plegado',
    showPunchMark: 'Mostrar marca de perforación',
    showPageNumbers: 'Mostrar números de página',
    visible: 'Visible',
    pageBreakBefore: 'Salto de página antes',
    content: 'Texto',
    contentHint: 'Dejar vacío para usar el texto capturado en el documento.',
    positionTitle: 'Posición y espaciado',
    positionX: 'X (mm)',
    positionY: 'Y (mm)',
    positionWidth: 'Ancho (mm)',
    positionHeight: 'Alto (mm)',
    paddingTop: 'Espacio arriba (mm)',
    paddingBottom: 'Espacio abajo (mm)',
    styleTitle: 'Apariencia',
    fontSize: 'Tamaño de fuente (pt)',
    alignLabel: 'Alineación',
    bold: 'Negrita',
    borderBottom: 'Regla inferior',
    background: 'Color de fondo',
    align: {
      left: 'Izquierda',
      center: 'Centro',
      right: 'Derecha',
    },
    tableDisplayTitle: 'Apariencia de la tabla',
    zebra: 'Pestañas de zebra',
    compact: 'Espaciado de fila compacto',
    headerBackground: 'Tinte de la fila de encabezado',
    headerColor: 'Color de la fila de encabezado',
    columnsTitle: 'Columnas',
    columnLabel: 'Etiqueta',
    totalsTitle: 'Bloque de totales',
    showTaxBreakdown: 'Mostrar desglose de impuestos',
    showCashDiscount: 'Mostrar descuento al por mayor',
    girocodeTitle: 'Código Giro',
    qrSize: 'Tamaño (mm)',
    qrAlign: 'Alineación',
    qrCaption: 'Mostrar título',
    logoTitle: 'Logo',
    logoHeight: 'Alto (mm)',
    showCompanyAddress: 'Mostrar dirección de la empresa',
    paymentTitle: 'Notificaciones',
    showPaymentTerms: 'Mostrar términos de pago',
    showTaxNotice: 'Mostrar aviso de impuestos',
    customerHeaderTitle: 'Datos del cliente',
    customerHeaderHint:
      'Los campos estándar públicos seleccionados, como el NIF-IVA, muestran el valor guardado del documento. Añadir un campo activa el bloque. Los campos adicionales siguen necesitando su autorización PDF.',
    customerHeaderSharedTypeHint:
      'Esta plantilla abarca varios tipos de documento. Los campos ausentes o no autorizados se omiten de forma segura.',
    customerHeaderColumns: 'Columnas',
    customerHeaderLabels: 'Etiquetas de campo',
    customerHeaderLayoutDefault: 'Usar el diseño del documento',
    customerHeaderLabelsShow: 'Mostrar siempre',
    customerHeaderLabelsHide: 'Solo valores',
    customerHeaderHideEmpty: 'Ocultar valores vacíos',
    customerHeaderFields: 'Selección de campos',
    customerHeaderUseLayout: 'Usar el diseño del documento',
    customerHeaderAllConfigured:
      'Se muestran todos los campos autorizados para PDF en el documento.',
    customerHeaderSelectedCount: '{{count}} campos seleccionados expresamente',
    customerHeaderSelected: 'Campos de cliente seleccionados',
    customerHeaderUnavailableField: 'Campo que ya no está disponible',
    customerHeaderMoveUp: 'Mover campo hacia arriba',
    customerHeaderMoveDown: 'Mover campo hacia abajo',
    customerHeaderRemove: 'Quitar campo de la selección',
    customerHeaderSearch: 'Buscar campos o categorías',
    customerHeaderSource: 'Filtrar tipo de campo',
    customerHeaderCategory: 'Filtrar categoría',
    customerHeaderLoadError: 'No se pudieron cargar los campos del cliente.',
    customerHeaderBlocked: 'Este campo no puede aparecer en archivos PDF.',
    customerHeaderNoFields: 'No se encontraron campos externos autorizados.',
  },
  meta: {
    addDocument: 'Añadir campo del documento',
    add: 'Añadir campo de cliente',
    rows: 'Filas de datos del documento',
    hint: 'Arrastre las filas o use las flechas. Los valores, etiquetas y permisos PDF proceden del documento guardado. El cuadro crece con su contenido; compruebe el tamaño real en la vista previa PDF. Los demás bloques son independientes.',
    showLabel: 'Mostrar etiqueta del campo',
    hideEmpty: 'Ocultar valores vacíos',
    chooseSample: 'Seleccione un documento para comprobarlo.',
    loadError:
      'No se pudieron cargar los campos o el documento. Compruebe sus permisos de lectura.',
    emptyValue: 'Valor vacío',
    configureLayout: 'Configurar permisos PDF de la cabecera del cliente',
    configureFields: 'Configurar campos personalizados',
    openDocument: 'Comprobar los valores guardados en el documento',
    standard: {
      documentNumber: 'Número de documento',
      documentDate: 'Fecha',
      customerNumber: 'Número de cliente',
      contactPerson: 'Persona de contacto',
      reference: 'Referencia',
      serviceDate: 'Fecha de servicio',
      deliveryDate: 'Fecha de entrega',
      validUntil: 'Válido hasta',
      dueDate: 'Vencimiento',
    },
    issues: {
      documentMissingSnapshot:
        'No hay una definición histórica legible para este campo. Revise los campos personalizados y sus permisos de lectura en el documento de ejemplo. Nunca se sustituyen por definiciones actuales.',
      documentNotReleased:
        'Este campo no está autorizado para PDF en su definición guardada o actual. Revise « Mostrar en PDF » en los campos personalizados; seleccionarlo en la plantilla no concede permiso.',
      unavailable:
        'Este campo no está disponible en el catálogo actual. Revise el tipo de documento, el estado y los permisos de lectura en los campos personalizados.',
      missingSnapshot:
        'No hay un valor guardado. Compruebe los datos del cliente en el documento; añada o actualice explícitamente el campo en un borrador si es necesario. Los datos actuales nunca lo sustituyen.',
      notConfigured:
        'El campo falta en el diseño guardado. Compruebe la selección de datos del cliente en el documento.',
      private:
        'Los campos internos o confidenciales no pueden aparecer en PDF. Revise su clasificación; seleccionarlos en una plantilla no concede permisos.',
      notReleased:
        'El campo o la sección no tiene permiso PDF en el documento guardado. Revise los permisos del documento; configure los valores predeterminados para nuevos documentos en la cabecera del cliente.',
      condition:
        'La condición guardada no se cumple o el campo está protegido. Revise la configuración de datos del cliente en el documento.',
      empty: 'El valor guardado está vacío y oculto.',
    },
  },
  preview: {
    title: 'Vista previa en PDF',
    sample: 'Documento de ejemplo',
    refresh: 'Recargar previsualización',
    updating: 'Actualizando previsualización …',
    emptyTitle: 'No se encuentra documento de ejemplo',
    emptyHint: 'Crea un documento de este tipo para ver la vista previa.',
  },
  editor: {
    loadError: 'No se pudo cargar la plantilla.',
    copyName: '{{name}} (copiar)',
    resetTitle: '¿Restablecer el diseño?',
    resetDescription:
      'Todas las personalizaciones de esta plantilla se reemplazan con el ajuste preestablecido “{{preset}}”. Se puede deshacer este paso.',
  },
  toast: {
    saved: 'La plantilla ha sido guardada.',
    duplicated: 'La plantilla ha sido duplicada.',
    defaultSet: 'La plantilla ahora es la predeterminada para este tipo de documento.',
  },
};
